export class ServerResponse {
  msg?: string | null;
  http_status_code?: number | null;
  constructor({
    msg,
    http_status_code,
  }: {
    msg?: string | null;
    http_status_code?: number | null;
  }) {
    this.msg = msg;
    this.http_status_code = http_status_code;
  }
}

export class ServerException implements Error {
  name: string;
  code: string | number | null;
  message: string;
  res: ServerResponse;

  constructor(res: ServerResponse) {
    this.name = 'ServerException';
    this.code = res.http_status_code || 'ServerException';
    this.message = res.msg || 'Server Exception';
    this.res = res;
  }
}
